// extracted by mini-css-extract-plugin
export default {"background":"WAFEQ5eLREWaGDxYBvVI"};